// Scroll reveal
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) entry.target.classList.add('visible');
  });
}, { threshold: 0.10 });
document.querySelectorAll('.reveal, .product-card').forEach(el => observer.observe(el));

// Nav sticky après le hero
const navSticky = document.getElementById('navSticky');
const heroWrapper = document.querySelector('.hero-wrapper');
if (navSticky && heroWrapper) {
  const heroH = heroWrapper.offsetHeight;
  window.addEventListener('scroll', () => {
    navSticky.classList.toggle('visible', window.scrollY > heroH - 80);
  });
}

// FAQ accordion
document.querySelectorAll('.faq-item').forEach(item => {
  item.addEventListener('click', () => item.classList.toggle('open'));
});

if (navSticky) {
  if (heroWrapper) {
    // Page d'accueil : apparaît après le hero
    window.addEventListener('scroll', () => {
      const trigger = heroWrapper.offsetHeight - 80;
      navSticky.classList.toggle('visible', window.scrollY > trigger);
    });
  } else {
    // Toutes les autres pages : toujours visible
    navSticky.classList.add('visible');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const reveals = document.querySelectorAll('.reveal');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, {
    threshold: 0.15
  });

  reveals.forEach(reveal => {
    observer.observe(reveal);
  });
});

/* ============================================================
   VANELY — Nav sticky exact comme HTML de référence
   Coller à la FIN de vanely.js
   ============================================================ */
(function () {
  'use strict';

  function initVanelySticky() {
    var sticky = document.getElementById('vanely-nav-sticky');
    if (!sticky) return;

    var heroWrapper = document.querySelector('.hero-wrapper');

    if (heroWrapper) {
      /* Homepage : apparaît quand on dépasse le hero */
      function onScroll() {
        var threshold = heroWrapper.offsetHeight - 80;
        if (window.scrollY > threshold) {
          sticky.classList.add('visible');
        } else {
          sticky.classList.remove('visible');
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else {
      /* Pages sans hero : toujours visible */
      sticky.classList.add('visible');
    }

    syncCartCount();
  }

  function syncCartCount() {
    var badge = document.getElementById('vanely-sticky-cart-count');
    if (!badge) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var n = cart.item_count || 0;
        badge.textContent = n > 0 ? n : '';
      })
      .catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVanelySticky);
  } else {
    initVanelySticky();
  }

  document.addEventListener('shopify:section:load', function() {
    initVanelySticky();
  });
})();


/* ============================================================
   VANELY.JS — Script principal
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ----------------------------------------------------------
     1. SCROLL REVEAL — .reveal et .product-card
  ---------------------------------------------------------- */
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.10 });

  document.querySelectorAll('.reveal, .product-card').forEach(function (el) {
    revealObserver.observe(el);
  });

  /* ----------------------------------------------------------
     2. FAQ ACCORDION
  ---------------------------------------------------------- */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    item.addEventListener('click', function () {
      item.classList.toggle('open');
    });
  });

});

/* ----------------------------------------------------------
   3. NAV STICKY VANELY — transparent sur hero, ivoire au scroll
      (fonctionne aussi avant DOMContentLoaded via window.onload)
---------------------------------------------------------- */
(function () {
  function initVanelySticky() {
    var sticky = document.getElementById('vanely-nav-sticky');
    if (!sticky) return;

    var heroWrapper = document.querySelector('.hero-wrapper');

    if (heroWrapper) {
      function onScroll() {
        var threshold = heroWrapper.offsetHeight - 80;
        sticky.classList.toggle('visible', window.scrollY > threshold);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else {
      sticky.classList.add('visible');
    }

    syncCartCount();
  }

  function syncCartCount() {
    var badge = document.getElementById('vanely-sticky-cart-count');
    if (!badge) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count || 0;
        badge.textContent = n > 0 ? n : '';
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVanelySticky);
  } else {
    initVanelySticky();
  }

  document.addEventListener('shopify:section:load', initVanelySticky);
})();
